// Abstracting this context logic to a utility file to
// avoid eslint 'dependency cycle detected' error:

import { createContext } from 'react';

export const TopicDrawerNavigationContext = createContext(null);

const TopicConfigContext = createContext(null);

export default TopicConfigContext;
